export function accordionQuiz() {
    const buttons = document.querySelectorAll('.accordion .title button');
    const accordion = document.querySelectorAll('.accordion');
    // const next1 = document.querySelector( '.next-1' );
    // const next2 = document.querySelector( '.next-2' );
    // const next3 = document.querySelector( '.next-3' );
    // const next4 = document.querySelector( '.next-4' );
    // const title1 = document.querySelector( '.title-1' );
    // const title2 = document.querySelector( '.title-2' );
    // const title3 = document.querySelector( '.title-3' );
    // const title4 = document.querySelector( '.title-4' );
    buttons.forEach(button => {
        button.addEventListener('click', function() {
            const accordion = this.closest('.accordion');
            const allTitles = accordion.querySelectorAll('.title');
            // const allNext = accordion.querySelectorAll('.next');
            
            allTitles.forEach(title => {
                if (title !== this.parentElement) {
                    title.classList.remove('open');
                }
            });
            // allNext.forEach(next => {
            //     next.classList.remove('hidden');
            // });
            this.parentElement.classList.toggle('open');
            this.parentElement.parentElement.classList.toggle('active');
            this.parentElement.parentElement.parentElement.classList.add('active');
            accordion.classList.add('open-answer');

            // if(this.parentElement.classList.contains('title-1')) {
            //     setTimeout(() => {
            //     this.parentElement.parentElement.parentElement.classList.add('delay');
            //     }, 1000); 
            //     next1.classList.add('hidden');
            // }
            // else if(this.parentElement.classList.contains('title-2')) {
            //     next1.classList.add('hidden');
            //     next2.classList.add('hidden');
            // }
            // else if(this.parentElement.classList.contains('title-3')) {
            //     next1.classList.add('hidden');
            //     next2.classList.add('hidden');
            //     next3.classList.add('hidden');
            // }
            // else if(this.parentElement.classList.contains('title-4')) {
            //     next1.classList.add('hidden');
            //     next2.classList.add('hidden');
            //     next3.classList.add('hidden');
            //     next4.classList.add('hidden');
            // }
        });
        
    });
    // next1.addEventListener('click', function() {
    //     title1.classList.toggle('open');
    //     title1.parentElement.classList.toggle('active');
    //     title1.parentElement.parentElement.classList.add('active');
    //     setTimeout(() => {
    //             title1.parentElement.parentElement.classList.add('delay');
    //             }, 200); 
    //     this.classList.add('hidden');
    //     accordion.classList.add('open-answer');
    // });
    // next2.addEventListener('click', function() {
    //     title2.classList.toggle('open');
    //     title2.parentElement.classList.toggle('active');
    //     title2.parentElement.parentElement.classList.add('active');
    //     title1.classList.remove('open');
    //     this.classList.add('hidden');
    //     accordion.classList.add('open-answer');
    // });
    // next3.addEventListener('click', function() {
    //     title3.classList.toggle('open');
    //     title3.parentElement.classList.toggle('active');
    //     title3.parentElement.parentElement.classList.add('active');
    //     title2.classList.remove('open');
    //     this.classList.add('hidden');
    //     accordion.classList.add('open-answer');
    // });
    //  next4.addEventListener('click', function() {
    //     title4.classList.toggle('open');
    //     title4.parentElement.classList.toggle('active');
    //     title4.parentElement.parentElement.classList.add('active');
    //     title3.classList.remove('open');
    //     this.classList.add('hidden');
    //     accordion.classList.add('open-answer');
    // });
}
